import { Component, EventEmitter, Inject, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { FormService } from '../organizations/features/booking/components/form/service';
import { Flightinfo } from '../models/flightModel';
import { DatePipe } from '@angular/common';
import { provideNativeDateAdapter } from '@angular/material/core';
import { PfFlightPickerComponent } from '../pf-flight-picker/pf-flight-picker.component';
import { ShuttlebussService } from '../services/shuttlebuss.service';
import { TranslocoModule } from '@jsverse/transloco';
import { timeout, catchError, of } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-flightpicker-modal',
  imports: [
    MatDatepickerModule,
    PfFlightPickerComponent,
    TranslocoModule
  ],
  providers: [provideNativeDateAdapter(), DatePipe],
  templateUrl: './flightpicker-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './flightpicker-modal.component.scss'
})
export class FlightPickerModalComponent implements OnInit {
  flights: Flightinfo[] = [];

  isFlightButtonEnabled = false;
  isLoadingFlights = false;
  selected: Date | null = null;
  currentSelectedTab: string = 'date';
  selectedFlight: Flightinfo | null = null;
  @Output() selectFlightEvent = new EventEmitter();
  minDate = new Date();
  @Output() flightTimeoutEvent = new EventEmitter<boolean>(false);
  @Output() noInternetEvent = new EventEmitter<boolean>(false);
  @Output() errorEvent = new EventEmitter<boolean>(false);

  constructor(
    public dialogRef: MatDialogRef<PfFlightPickerComponent>,
    private shuttlebussService: ShuttlebussService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: {
      form: FormService,
      type: string,
      selectedDate: Date | null,
      selectedFlight: Flightinfo | null,
    },
    public datepipe: DatePipe
  ) { }

  getFlightsByDate(date: any, type: any) {
    this.isLoadingFlights = true;
    this.isFlightButtonEnabled = false;
    this.shuttlebussService.getFlights(date, type)
      .pipe(
        timeout(30000),
        catchError((error) => {
          if (!navigator.onLine) {
            console.error("No internet connection detected.");
            this.noInternetEvent.emit(true);
          } else if (error.name === 'TimeoutError') {
            console.error("API Timeout: The request took too long.");
            this.flightTimeoutEvent.emit(true);
          } else {
            console.error("API Error:", error);
            this.errorEvent.emit(true);
          }
          this.isLoadingFlights = false;
          this.isFlightButtonEnabled = true;
          return of([]);
        })
      )
      .subscribe(

        {
          next: (FlightList: Flightinfo[]) => {
            let Timekey: string = type + "Time";

            this.flights = FlightList
              .filter(
                flight => {
                  let flightTime: any = flight[Timekey as keyof Flightinfo];
                  let currentDate = new Date();
                  let swedishTimeOffset = 2; //@PAC change this to properly handle daylight savings (proper tz support )
                  currentDate.setHours(currentDate.getUTCHours() + swedishTimeOffset);
                  return flight.locationAndStatus.flightLegStatus !== 'DEL' &&
                    flight.locationAndStatus.flightLegStatus !== 'Deleted' &&
                    new Date(flightTime.scheduled) > currentDate

                }).sort((a, b) => {
                  let flightTimeA: any = a[Timekey as keyof Flightinfo]
                  let flightTimeB: any = a[Timekey as keyof Flightinfo]
                  return flightTimeA.scheduled < flightTimeB.scheduled ? -1 : 1
                });

            this.isFlightButtonEnabled = true;
            this.isLoadingFlights = false;
          },
          error: (error: any) => {
          },
          complete: () => {
          }
        }
      );
  }

  ngOnInit(): void {
    this.selected = this.data.selectedDate;
    if (this.selected) {

      this.getFlightsByDate(this.datepipe.transform(this.selected, 'yyyy-MM-dd'), this.data.type);
    }
    // this.selectedFlight = this.data.selectedFlight;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectFlight(flight: Flightinfo): void {
    this.selectedFlight = flight
    this.selectFlightEvent.emit(flight);
    this.dialogRef.close();
  }
}